// src/pages/Service/Service Entry/components/CreateServiceForm.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Form,
  Grid,
  DatePicker,
  Typography,
  Flex,
  Radio,
  Select,
  Checkbox,
  message,
  Button,
  Drawer,
  Tooltip,
} from "antd";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { QuestionCircleOutlined } from "@ant-design/icons";

import InputField from "../../../../../components/Input/Input";
import SearchListAutoComplete from "../../../../../components/SearchListAutoComplete";
import Swal from "sweetalert2";

import {
  fetchCustomers,
  fetchItems,
  fetchTaxAccs,
  fetchDiscountAccs,
  fetchTagGroupFields,
} from "../../../../../store/commonThunks/lookups";
import {
  selectDiscountAccs,
  selectTaxAccs,
} from "../../../../../store/commonSelectors/lookupsSelectors";
import {
  fetchServiceEntryNumber,
  fetchServiceRecord,
  fetchServiceAccs,
} from "../serviceThunk";
import { dateTimeFormat, formatToCompanyTimezone, getYearFromCompanyDate } from "../../../../../lib/functions";
import {
  resetServiceEntry,
  setCustomer,
  setEntryDate,
  setDueDate,
  addOrderRow,
  setTaxMode,
  setFormField,
  setServiceAcc,
  setTaxAcc,
  setDiscountAcc,
  setTagFeildNameid,
  setConversion,
  setConversionRate,
  clearServiceForCustomerChange,
  calculateTotals,
} from "../serviceSlice";
import StaticAutoComplete from "../../../../../components/StaticAutoComplete";
import { getCurrencyCodeWithName } from "../../../../../lib/currency";
import { convertCurrency } from "../../../../../utils";
import { selectAuthInfo } from "../../../../Auth/authSelectors";
import CustomerDrawer from "../../../../Customers/components/CustomerDrawer";
import AddNewModal from "../../../../../components/DropDown/AddNewModal";
import TagCreateForm from "../../../../Settings/Tags/components/TagCreateForm";
import useMigrationDate from "../../../../../hooks/useMigrationDate";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateServiceForm = ({ editId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const location = useLocation();
  const [form] = useForm();
  const { id } = useParams();
  const lookups = useSelector((s) => s.lookups);
  const authInfo = useSelector(selectAuthInfo);
  const currency = authInfo?.currency || "AED";

  console.log(id, "id12345");



  const {
    customerInfo,
    voucherNumber,
    entryDate,
    dueDate,
    itemCart,
    taxMode,
    serviceAccs,
    selectedServiceAcc,
    conversionRate,
    tag_field_id
  } = useSelector((s) => s.serviceEntry);
  const [isConvertCurrencyShow, SetIsConvertCurrencyShow] = useState(false);
  const [customerDrawerOpen, setCustomerDrawerOpen] = useState(false);
  const [tagModal, setTagModal] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);

  const isFieldHidden = (fieldKey, pageKey = "service_entry") => {
    return authInfo?.visibilitytabs?.some(
      (item) => item.page_key === pageKey && item.field_key === fieldKey
    );
  };

  useEffect(() => {
    if (editId) return
    let formatedDate = entryDate ? dayjs(entryDate).toISOString() : null;
    let companydate = formatToCompanyTimezone(formatedDate);
    const year = getYearFromCompanyDate(companydate);
    dispatch(fetchServiceEntryNumber(year));
  }, [entryDate]);

  let tags =
    lookups.tagFields.map((tag) => ({
      label: tag.display_text,
      // value: tag.display_text,
      value: tag.id,
      tagid: tag.id,
    })) || [];

  useEffect(() => {
    dispatch(fetchCustomers(""));
    dispatch(fetchTagGroupFields(""));
    dispatch(fetchServiceAccs());
    dispatch(fetchItems(""));

    dispatch(fetchTaxAccs()).then((res) => {
      if (res.payload && res.payload.length > 0) {
        dispatch(setTaxAcc(res.payload[0])); // pick first as default
      }
    });
    dispatch(fetchDiscountAccs()).then((res) => {
      if (res.payload && res.payload.length > 0) {
        dispatch(setDiscountAcc(res.payload[0])); // pick first as default
      }
    });
   
  }, [dispatch]);

  // AutoSelect service account on pageload
  useEffect(() => {
    if (
      serviceAccs?.length === 1 &&
      !selectedServiceAcc   // avoid overriding user choice
    ) {
      const acc = serviceAccs[0];

      dispatch(setFormField({ field: "selectedServiceAcc", value: acc }));
      dispatch(setServiceAcc(acc));
    }
  }, [serviceAccs, selectedServiceAcc, dispatch]);


  console.log(editId, "editId123");


  useEffect(() => {
    if (!editId) return;
    console.log(location, "location");

    dispatch(fetchServiceRecord({ location }));
  }, [location, dispatch]);

  const handleCustomerSelect = (cust) => {
    if (cust === "add_new") {
      setCustomerDrawerOpen(true);
      return;
    }

    if (!cust) {
      dispatch(resetServiceEntry());
      return;
    }

    // 🔥 CLEAR OLD SERVICE DATA
    dispatch(clearServiceForCustomerChange());

    dispatch(setCustomer(cust));
    let formatedDate = entryDate ? dayjs(entryDate).toISOString() : null;
    let companydate = formatToCompanyTimezone(formatedDate);
    const year = getYearFromCompanyDate(companydate);
    dispatch(fetchServiceEntryNumber(year));
    // dispatch(fetchServiceRecord({ location }));

    // Ensure at least one row
    dispatch(
      addOrderRow({
        key: Date.now(),
        item_id: null,
        product: "",
        quantity: 1,
        rate: 0,
        tax_per: 0,
        discount: 0,
        discountAmt: null,
        discountMode: "percent",
        item_description: "",
        showDescription: false,
        bonus: false,
      })
    );
  };


  const handletaggroup = (e, selectedOption) => {
    const value = selectedOption?.map((tag) => tag.tagid);

    dispatch(setTagFeildNameid(value));
  };
const {disabledDate} = useMigrationDate();
  return (
    <div>
      <Flex justify="space-between" align="center">
        <Title level={3}>
          Service Entry
        </Title>

        <Tooltip title="Help">
          <Button
            type="text"
            icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
            onClick={() => setHelpOpen(true)}
          />
        </Tooltip>
      </Flex>
      <Form
        form={form}
        layout={!screens.md ? "vertical" : "horizontal"}
        style={{ width: "100%", maxWidth: "1200px" }}
        colon={false}
        labelCol={!screens.md ? undefined : { span: 8 }}
        wrapperCol={!screens.md ? undefined : { span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          {/* Customer Info */}
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item label="Search Customer" required>
              <SearchListAutoComplete
                entityType="customer"
                placeholder="Customer"
                optionsList={lookups.customers.map((c) => ({
                  sale_id: c.acc_id,
                  display_text: c.acc_name || c.institution_name,
                  raw: c,
                }))}
                value={
                  customerInfo?.acc_id
                    ? {
                      value: customerInfo.acc_name,
                      label: customerInfo.acc_name,
                      display_text: customerInfo.acc_name,
                      raw: customerInfo,
                    }
                    : null
                }
                onSelect={(obj) => handleCustomerSelect(obj?.raw ? obj.raw : obj)}
                showAddNew={true}
              />
            </Form.Item>
            <Form.Item label="Institution Name">
              <InputField value={customerInfo?.institution_name} disabled />
            </Form.Item>
            <Form.Item label="Customer Address">
              <InputField value={customerInfo?.address} disabled />
            </Form.Item>
            <Form.Item label="Contact No">
              <InputField value={customerInfo?.contact_no} disabled />
            </Form.Item>

              <Form.Item label="Discount">
                <Radio.Group
                  options={[
                    { label: "On Total", value: "on_total" },
                    { label: "On Individual Item", value: "on_item" },
                  ]}
                  onChange={(e) => {
                    dispatch(setTaxMode(e.target.value))
                    dispatch(calculateTotals({ authInfo }));
                  }}
                  value={taxMode}
                />
              </Form.Item>
          </Flex>

          {/* Order Info */}
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item label="Voucher No">
              <InputField
                value={voucherNumber || ""}
                disabled
                data-testid="service-no"
              />
            </Form.Item>
            <Form.Item label="Entry Date" required>
              <DatePicker
                style={{ width: "100%" }}
                value={entryDate ? dayjs(entryDate) : null}
                onChange={(d) =>
                  dispatch(setEntryDate(d ? d.toISOString() : null))
                }
                format={dateTimeFormat}
                                            disabledDate={disabledDate}
              />
            </Form.Item>
            <Form.Item label="Service Account" rules={[{ required: true }]}>
              <StaticAutoComplete
                optionsList={serviceAccs}
                value={selectedServiceAcc ? selectedServiceAcc : null}
                onSelect={(acc) => {
                  dispatch(
                    setFormField({ field: "selectedServiceAcc", value: acc })
                  );
                  dispatch(setServiceAcc(acc));
                }}
                onClear={() => {
                  dispatch(
                    setFormField({ field: "selectedServiceAcc", value: null })
                  );
                  dispatch(setServiceAcc(null));
                }}
                placeholder="Select a service account"
                disabled={!serviceAccs?.length}
              />
            </Form.Item>
            <Form.Item label="Search Tags">
              <Select
                data-testid="roles-select"
                className="tag-multiselect"
                maxTagCount="responsive"
                mode="multiple"
                value={tag_field_id || null}
                style={{ width: "100%" }}
                onChange={(e, options) => handletaggroup(e, options)}
                placeholder="Select Tags"
                options={tags}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: 8,
                        borderTop: "1px solid #f0f0f0",
                      }}
                    >
                      <Button type="link" onClick={() => setTagModal(true)}>
                        + Add New Tag
                      </Button>
                    </div>
                  </>
                )}
              />
            </Form.Item>

            {/* <Form.Item label="Due Date">
              <DatePicker
                style={{ width: "100%" }}
                value={dueDate ? dayjs(dueDate) : null}
                onChange={(d) =>
                  dispatch(setDueDate(d ? d.toISOString() : null))
                }
                format="DD/MM/YYYY"
              />
            </Form.Item> */}
            {!isFieldHidden("Convert Currency") && (
              <Form.Item>
                <Checkbox
                  onChange={(e) => {
                    SetIsConvertCurrencyShow(e.target.checked ? true : false);
                  }}
                >
                  Convert Currency
                </Checkbox>
              </Form.Item>
            )}
          </Flex>
        </Flex>
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          {isConvertCurrencyShow && (
            <>
              <Flex
                vertical
                gap={10}
                style={{
                  width: !screens.md || !screens.xl ? "100%" : "40%",
                }}
              >
                <Form.Item label="Choose Currency">
                  <Select
                    showSearch
                    placeholder="Select Currency"
                    style={{ width: "100%", minWidth: 200 }}
                    options={getCurrencyCodeWithName().map((c) => ({
                      value: c.code,
                      label: `${c.currency} (${c.code})`,
                    }))}
                    onChange={async (toCurrency) => {
                      const rate = await convertCurrency(currency, toCurrency);

                      if (rate) {
                        dispatch(
                          setConversion(toCurrency, "conversion_currency")
                        );
                        dispatch(setConversionRate(rate));
                      }
                    }}
                  />
                </Form.Item>
              </Flex>
              <Flex
                vertical
                gap={10}
                style={{
                  width: !screens.md || !screens.xl ? "100%" : "40%",
                }}
              >
                <Form.Item label="Conversion Rate">
                  <InputField value={conversionRate} disabled />
                </Form.Item>
              </Flex>
            </>
          )}
        </Flex>
      </Form>

      <CustomerDrawer
        open={customerDrawerOpen}
        onClose={() => setCustomerDrawerOpen(false)}
        authInfo={authInfo}
        onCreated={(customer) => {
          if (!customer) return;

          //  Close drawer
          setCustomerDrawerOpen(false);

          dispatch(fetchCustomers());
          //  Update Redux
          dispatch(setCustomer(customer));
          // dispatch(fetchServiceRecord({ location }));

          form.setFieldValue("search_customer", {
            value: customer.acc_name,
            label: customer.acc_name,
            display_text: customer.acc_name,
            raw: customer,
          });

          dispatch(clearServiceForCustomerChange());

          if (itemCart.length === 0) {
            const newRow = {
              key: Date.now(),
              item_id: null,
              product: "",
              quantity: 1,
              rate: 0,
              tax_per: 0,
              discount: 0,
              discountAmt: null,
              discountMode: "percent",
              bonus: false,
            };
            dispatch(addOrderRow(newRow));
          }


          //  Trigger dependent flows
          dispatch(fetchItems(customer?.party_type || false));

          dispatch(fetchTaxAccs()).then((res) => {
            if (res.payload?.length) {
              dispatch(setTaxAcc(res.payload[0]));
            }
          });

          dispatch(fetchDiscountAccs()).then((res) => {
            if (res.payload?.length) {
              dispatch(setDiscountAcc(res.payload[0]));
            }
          });
        }}
      />

      <AddNewModal
        open={tagModal}
        title="Add Tag"
        onClose={() => setTagModal(false)}
      >
        <TagCreateForm
          authInfo={authInfo}
          onSuccess={async ({ groupId, createdName }) => {
            const res = await dispatch(fetchTagGroupFields("")).unwrap();

            const match = res.find(
              (t) =>
                t?.raw?.field_name?.toLowerCase() ===
                createdName.toLowerCase()
            );

            if (!match) {
              message.warning("Tag creation failed or tag not found");
              setTagModal(false);
              return;
            }

            if (tag_field_id.includes(match.id)) {
              message.info("Tag already exists and is already selected");
              setTagModal(false);
              return;
            }

            // ✅ New tag OR existing but not selected
            dispatch(setTagFeildNameid([...tag_field_id, match.id]));
            message.success("Tag added");

            setTagModal(false);
          }}
        />
      </AddNewModal>
      <Drawer
        title="Service Entry Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={!screens.sm ? "100%" : 420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Service Entry
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Service Entry module is used to create and manage customer
            service transactions within the ERP system. It helps track
            service details, billing, taxes, and customer-related service
            activities efficiently.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Steps to Create Service Entry</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Open <strong>Service → Service Entry</strong></li>
              <li>Select or create the customer</li>
              <li>Verify voucher number and entry date</li>
              <li>Select the service account</li>
              <li>Add service items with quantity and pricing</li>
              <li>Apply discounts if required</li>
              <li>Add tags or additional notes if needed</li>
              <li>Review totals and service details</li>
              <li>Click <strong>Save</strong> to complete the service entry</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Customer and service account selection are required.</li>
              <li>Service totals change based on VAT and discount settings.</li>
              <li>Currency conversion can be enabled if required.</li>
              <li>Verify service details carefully before saving.</li>
            </ul>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default CreateServiceForm;
